import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-input-icon',
  templateUrl: './input-icon.component.html',
  styleUrls: ['./input-icon.component.scss'],
})
export class InputIconComponent implements OnInit {
  @Input() placeholder: string = '';
  @Input() type: string = 'text';
  @Input() maxLength: string = '128';
  @Input() icon: string = 'close';
  @Output() fieldInputValue = new EventEmitter<string>();

  @Input() fieldValue: string = '-';

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    //si hay cambios en el fieldValue llama al metodo getValue
    if (changes['fieldValue'] && changes['fieldValue'].currentValue !== changes['fieldValue'].previousValue) {
      this.getValue(this.fieldValue);
    }
  }
  getValue(value: string) {    
    this.fieldValue = value;
    this.fieldInputValue.emit(this.fieldValue);
  }

  clearText() {
    this.getValue('');
  }
}
